/**
 * Featured Products (Homepage)
 * ─────────────────────────────
 * A curated list of Shopify products to feature on the Home page's
 * "Featured Products" section. This is *website content*, not environment
 * configuration — edit this file whenever the merchant selects new products
 * to feature.
 *
 * ── HOW TO CONFIGURE A REAL PRODUCT ─────────────────────────────────────
 *   1. Copy the Shopify product page URL          → `productUrl`
 *   2. Copy the primary product image URL         → `imageUrl`
 *      (right-click the product image on Shopify → "Copy image address")
 *   3. Write the display price exactly as it should render (e.g. "$24.99")
 *      → `displayPrice`
 *   4. Enter the product title exactly as it should render → `title`
 *   5. (Optional) short one-line tagline           → `tagline`
 *   6. (Optional) small badge label ("New", "Limited", "Popular", etc.)
 *      → `badge`
 *   7. Flip `enabled: true` when the four fields above are all filled in.
 *
 * Any slot with `enabled: false` (or missing `title` / `productUrl` /
 * `imageUrl`) is HIDDEN from the homepage — no decorative placeholder is
 * shown, no setup hint is exposed to visitors. Prices and product art are
 * NEVER invented.
 *
 * Nothing about Shopify checkout, cart behavior, product IDs, or pricing
 * logic depends on this file — this is purely display metadata for the
 * homepage tile.
 * ────────────────────────────────────────────────────────────────────────
 */

export const FEATURED_PRODUCTS = [
  {
    // Slot 1 — TODO: fill in with real Shopify data, then set enabled: true.
    enabled: false,
    title: "",
    productUrl: "",
    imageUrl: "",
    displayPrice: "",
    tagline: "",
    badge: "",
  },
  {
    // Slot 2 — TODO: fill in with real Shopify data, then set enabled: true.
    enabled: false,
    title: "",
    productUrl: "",
    imageUrl: "",
    displayPrice: "",
    tagline: "",
    badge: "",
  },
  {
    // Slot 3 — TODO: fill in with real Shopify data, then set enabled: true.
    enabled: false,
    title: "",
    productUrl: "",
    imageUrl: "",
    displayPrice: "",
    tagline: "",
    badge: "",
  },
  {
    // Slot 4 — TODO: fill in with real Shopify data, then set enabled: true.
    enabled: false,
    title: "",
    productUrl: "",
    imageUrl: "",
    displayPrice: "",
    tagline: "",
    badge: "",
  },
];

/** Returns only the fully-configured, enabled products. */
export function getEnabledFeaturedProducts() {
  return FEATURED_PRODUCTS.filter(
    (p) =>
      p &&
      p.enabled === true &&
      (p.title || "").trim() &&
      (p.productUrl || "").trim() &&
      (p.imageUrl || "").trim(),
  );
}
